export default __webpack_public_path__ + "static/media/group-28-copy.0830c6ae.svg";